import { render, staticRenderFns } from "./AlertaVigenciaFormacionInicialPersonalComponent.vue?vue&type=template&id=3f42a6ee"
import script from "./AlertaVigenciaFormacionInicialPersonalComponent.vue?vue&type=script&lang=js"
export * from "./AlertaVigenciaFormacionInicialPersonalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports